import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomerRegisterRequest, LoyaltyCardResponse } from '../models/loyalty.model';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyService {

  private apiUrl = environment.api + `api/erp/loyalty-card`; 

  constructor(private http: HttpClient) { }


  registerPublicCustomer(payload: CustomerRegisterRequest): Observable<LoyaltyCardResponse> {
    return this.http.post<LoyaltyCardResponse>(`${this.apiUrl}/public/registerRmnHub`, payload);
  }
}